import React from 'react';
import './ui.css';

export function IconButton({ children, className = '', onClick, title, ...props }) {
  return (
    <button
      className={`icon-button ${className}`}
      onClick={onClick}
      title={title}
      {...props}
    >
      {children}
    </button>
  );
} 